import { sbEditable } from '@storyblok/storyblok-editable';
import classNames from 'classnames';
import type { ReactElement, RefObject } from 'react';
import { useRef } from 'react';
import Heading from 'components/atoms/heading/Heading';
import LottieView from '../../../atoms/lottie-view/LottieView';
import type { TickerTextItemProps } from './TickerTextItem.data';
import styles from './TickerTextItem.module.scss';

export default function TickerTextItem({
  className,
  blok,
  ref,
}: TickerTextItemProps): ReactElement {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLElement | null>;

  //   'icon-rising-sun',
  //   'icon-petal',
  //   'icon-pinwheel',
  //   'icon-wave',
  //   'icon-moon',
  //   'icon-fan',
  //   'icon-enso',
  //   'icon-bonsai',

  return (
    <div
      ref={elementRef as RefObject<HTMLDivElement | null>}
      className={classNames(styles.tickerTextItem, className)}
      {...sbEditable(blok)}
    >
      <div className={classNames(styles.iconHolder)}>
        <LottieView id={blok.symbol.icon} loop autoplay pauseWhenOutViewport />
      </div>
      <Heading
        className={classNames(styles.title)}
        as="h2"
        transitionInType="none"
        size="heading-02"
      >
        {blok.text}
      </Heading>
    </div>
  );
}
